const API_URL = 'https://qxoe8xxub9.execute-api.us-east-1.amazonaws.com/prod';
export default API_URL;
